import React from "react";
import { Grid } from "@material-ui/core";
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
import { Image } from "react-bootstrap";

function NotifyTemplate({ background, heading, content, template, image, ...props }) {
    const imgSrc = image.url || 'https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
    return (
        <React.Fragment>
            <Grid container alignItems="center" justify="center" >
                <Grid item xs style={{ textAlign: "center" }}>Template Preview</Grid>
                <Grid item xs={12} style={{ padding: "10px 20px" }}>
                    {template !== "IMAGE" ?
                        (<>
                            <div style={{
                                maxWidth: "280px", maxHeight: "460px",
                                backgroundColor: background.color, boxShadow: "0px 0px 5px #888888",
                                borderRadius: "4px", position: "relative"
                            }}>
                                <div style={{
                                    color: heading.color,
                                    textAlign: "center", paddingTop: "24px",
                                    fontSize: "20px", margin: "auto",
                                    fontWeight: "600", maxWidth: "200px"
                                }}>
                                    {heading.value}
                                </div>
                                {template === "TEXT_IMAGE" &&
                                    <div style={{
                                        width: "200px", margin: '8px auto',
                                        height: "200px", borderRadius: "4px",
                                        backgroundImage: `url(${imgSrc})`, backgroundSize: "cover"
                                    }}>
                                    </div>}
                                <div style={{
                                    color: content.color, textAlign: "center",
                                    marginTop: "12px", paddingBottom: "24px",
                                    fontSize: "16px", margin: "auto",
                                    fontWeight: "400", maxWidth: "240px"
                                }}>
                                    {content.value}
                                </div>
                                <div style={{ position: 'absolute', right: "4px", top: "4px" }}>
                                    <CloseSharpIcon />
                                </div>
                            </div>
                        </>) : (
                            <>
                                <div style={{
                                    width: "280px", height: "420px",
                                    backgroundImage: `url(${imgSrc})`,
                                    boxShadow: "0px 0px 5px #888888", borderRadius: "4px",
                                    position: "relative", backgroundSize: "cover"
                                }}>
                                    <div style={{ position: 'absolute', right: "4px", top: "4px" }}>
                                        <CloseSharpIcon />
                                    </div>
                                </div>

                            </>
                        )}
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default NotifyTemplate;
